import { Livewire } from '@shared/livewire.js'
import '@shared/forms/stripe.js'

Livewire.start()
